import { render, staticRenderFns } from "./BnTile.vue?vue&type=template&id=0979f366&scoped=true&"
import script from "./BnTile.vue?vue&type=script&lang=js&"
export * from "./BnTile.vue?vue&type=script&lang=js&"
import style0 from "./BnTile.vue?vue&type=style&index=0&id=0979f366&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0979f366",
  null
  
)

export default component.exports